export default __webpack_public_path__ + "static/media/easyTravel.d25cfd12.PNG";